import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  labelingData: {
    vendors: '',
    leads: '',
  },
};

const labelingSlice = createSlice({
  name: 'labeling',
  initialState,
  reducers: {
    getLabelingData(state, action) {
      state.labelingData = {
        vendors: action.payload.vendors || '',
        leads: action.payload.leads || '',
      };
    },
  },
});

export default labelingSlice.reducer;
export const { getLabelingData } = labelingSlice.actions;
